import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation createCategoryMutation($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      categoryEdge {
        node {
          ...CategoryCell_category
        }
      }
      lists {
        ...CategoryList_lists
      }
      errors {
        key
        messages
      }
    }
  }
`;

const createCategory = (environment, name, listsId, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: { name },
    },
    configs: [
      {
        type: 'RANGE_ADD',
        parentID: listsId,
        edgeName: 'categoryEdge',
        connectionInfo: [
          {
            key: 'CategoryList_categories',
            rangeBehavior: 'append',
          },
        ],
      },
    ],
    ...args,
  });
};

export default createCategory;
